import React, {Component} from 'react'
import { Link, NavLink, Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {Collapse} from 'react-collapse';
import {
  getNavigationMenuList,
} from '../../services/reservoir'
import { getProperty } from '../../helpers/properties';
import {updateMyResourcesTertiaryItems} from "../../services/vu";
import classNames from 'classnames';
import {getConfiguration} from "../../helpers/configuration";

const mapStateToProps = ({courses: { selectedCourseCode, data }, course: { selectedCourse }}) => {
  return {
    courseTitle: selectedCourse.courseTitle,
    admissionCategory: selectedCourse.admissionCategory,
  }
}

class MegaNav extends Component {
  constructor (props) {
    super(props)

    this.state = {
      secondaryItems: [],

      activeSecondaryId: '',
      activeTertiaryTitle: '',

      currentSecondaryTile: '',
      currentTertiaryTitle: '',

      isMegaNavOpen: false,
    }
  }

  componentDidMount () {
    this.populateHeader()
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname || prevProps.admissionCategory !== this.props.admissionCategory) {
      this.populateHeader()
    }

    if (prevProps.match.params.articleId !== this.props.match.params.articleId) {
      this.setState({
        isMegaNavOpen: false,
      })
    }
  }

  updateTertiaryItems = taxonomyId => {
    updateMyResourcesTertiaryItems(taxonomyId, this.props.admissionCategory).then((relatedPages = []) => {
      this.setState({
        secondaryItems: this.state.secondaryItems.map(secondaryItem => Object.assign({}, secondaryItem, {
          tertiaryItems: secondaryItem.id === taxonomyId ? relatedPages : secondaryItem.tertiaryItems
        })),
      })
    })
  }

  getTertiaryItems = taxonomyId => {
    const secondaryItem = this.state.secondaryItems.find(({id}) => id === taxonomyId)
    if (secondaryItem && secondaryItem.tertiaryItems) {
      return secondaryItem.tertiaryItems
    }
    return []
  }

  populateHeader = () => {
    getNavigationMenuList().then((menuList) => {
      // console.log('menuList:', menuList)
      const menuItem = menuList.find((item) => {
        // TODO: should be - (item.name === this.props.courseTitle) , after updating 'My Guide' to 'My Resources' courseTitle in Drupal
        return (item.name === "My Resources");
      });

      if (menuItem && menuItem.child) {
        this.setState({
          secondaryItems: menuItem.child.map(child => Object.assign({}, child, {
            tertiaryItems: [],
          }))
        }, () => {
          this.state.secondaryItems.forEach(({id}) => this.updateTertiaryItems(id))
        })
      }
    });
  }

  getSecondaryTitleById = secondaryId => {
    const item = this.state.secondaryItems.find(({id}) => id === secondaryId)
    if (item) {
      return item.name
    }
    return ''
  }

  getTopNavItems = () => {
    return this.state.secondaryItems.map((item, index) => (
      <li key={index}>
        <button
          onMouseOver={() => {
            this.updateTertiaryItems(item.id)

            this.setState({
              isMegaNavOpen: true,
              activeSecondaryId: item.id,
            })
          }}
          onMouseOut={() => {
            this.setState({
              isMegaNavOpen: false
            })
          }}
          className={classNames(
            {'secondary-nav__menu--hover': this.state.isMegaNavOpen && this.state.activeSecondaryId === item.id},
            {'secondary-nav__menu--active': !this.state.isMegaNavOpen && this.getTertiaryItems(item.id).some(({taxonomyId, id}) => {
              return taxonomyId === item.id && id === this.props.match.params.articleId
            })}
          )}
        >
          {item.name}
        </button>
      </li>
    ))
  }

  render () {
    return (
      <div>
        <div className="secondary-nav">
          {/*Secondary Nav Title*/}
          <div className="secondary-page__container">
            <ul>
              {this.getTopNavItems()}
            </ul>
          </div>

          {/*Tertiary Nav Title*/}
          <Collapse isOpened={this.state.isMegaNavOpen}>
            <div
              className="secondary-nav__dropdown"
              onMouseOver={() => {
                this.setState({
                  isMegaNavOpen: true
                })
              }}
              onMouseOut={() => {
                this.setState({
                  isMegaNavOpen: false
                })
              }}
            >
              <div className="secondary-page__container">
                {/*<div>*/}
                <ul className="secondary-nav__links">
                  {
                    this.getTertiaryItems(this.state.activeSecondaryId).map((tertiaryTitle, index) => {
                        return (
                          <li key={index}>
                            <Link to={getConfiguration('baseUrl') + '/resources/' + tertiaryTitle.id}
                                  id={tertiaryTitle.id}
                                  onClick={() => {
                                    // this.props.openNav(!this.props.pageNavigationOpen);
                                    this.setState({
                                      currentSecondaryTitle: this.getSecondaryTitleById(this.state.activeSecondaryId),
                                      currentTertiaryTitle: tertiaryTitle.heading,
                                    })
                                  }}
                            >{tertiaryTitle.heading}</Link>
                          </li>
                        )
                      }
                    )}
                </ul>
                {/*</div>*/}
              </div>
            </div>
          </Collapse>
        </div>
        <div className="breadcrumbs">
          <div className="secondary-page__container">
            <Route path={getConfiguration('baseUrl') + '/resources'} exact render={() => {
              return (
                <ul>
                  <li className="home"><Link to={getConfiguration('baseUrl') + '/resources'}>Home</Link></li>
                  <li><Link to={getConfiguration('baseUrl') + '/resources'}>My Resources</Link></li>
                </ul>
              )
            }}/>
            <Route path={getConfiguration('baseUrl') + '/resources/:articleId'} render={({match}) => {
              return (
                <ul>
                  <li className="home"><Link to={getConfiguration('baseUrl') + '/resources'}>Home</Link></li>
                  <li><Link to={getConfiguration('baseUrl') + '/resources'}>My Resources</Link></li>
                  {this.state.currentSecondaryTitle ? <li>{this.state.currentSecondaryTitle}</li> : ''}
                  {this.state.currentTertiaryTitle ? <li>{this.state.currentTertiaryTitle}</li> : ''}
                </ul>
              )
            }}/>
          </div>
        </div>
      </div>


    )
  }
}

export default withRouter(connect(mapStateToProps)(MegaNav))
